export const X_SEEK_SITE_AD_BUDGET_PURCHASE = 'ad-budget-purchase';
export const SOURCE_CHECKOUT = 'checkout';
export const SEEK_REQUEST_COUNTRY_HEADER = 'seek-request-country';
